import React, { useCallback, useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { routes } from '@constants/routes.const'
import { VelvetSDK } from 'sdk'
import { getActiveProfile } from '@utils/helpers'

const ProtectedHomeRoutes = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const handleLoginSuccess = useCallback(() => {
    setIsLoggedIn(true)
    const activeProfile = getActiveProfile()

    if (!activeProfile && !location.pathname.includes(routes.MANAGE_PROFILES)) {
      navigate(routes.MANAGE_PROFILES, { replace: true })
    }
  }, [location.pathname, navigate])

  const handleLoginError = useCallback(() => {
    setIsLoggedIn(false)
    navigate(routes.INITIAL_PAGE)
  }, [navigate])

  const checkUser = useCallback(async () => {
    const validTokens = await VelvetSDK.TokenManager.service.getTokens()

    validTokens ? handleLoginSuccess() : handleLoginError()
  }, [handleLoginError, handleLoginSuccess])

  useEffect(() => {
    checkUser()
  }, [checkUser])

  return <>{isLoggedIn ? <Outlet /> : null}</>
}

export default ProtectedHomeRoutes
